import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PlanCategory } from 'src/app/shared/models/planCategoryModel';
import { BaseService } from './base/base.service';
import { ErrorHandlerService } from './error-handler.service';

@Injectable({
  providedIn: 'root'
})
export class PlanCategoryService extends BaseService {
  private apiUrl = `${environment.publicApiSocioUrl}v1/socio/plan-category`;

  constructor(http: HttpClient, errorHandlerService: ErrorHandlerService) {
    super(http, errorHandlerService);
  }

  getAll(page: number = 0, size: number = 100): Observable<any> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    
    return this.get<any>(`${this.apiUrl}?page=${page}&size=${size}`);
  }

  getById(id: string): Observable<PlanCategory> {
    return this.get<PlanCategory>(`${this.apiUrl}/${id}`);
  }

  searchByName(name?: string, page: number = 0, size: number = 100): Observable<any> {
    let url = `${this.apiUrl}/search?page=${page}&size=${size}`;
    
    if (name) {
      url += `&name=${encodeURIComponent(name)}`;
    }
    
    return this.get<any>(url);
  }
}
